export default __webpack_public_path__ + "static/media/el21.33dd5a3e.svg";